import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { PostgreSqlDataset } from 'app/model/dataset/postgre-sql.dataset';
import { Metamodel } from 'app/model/base/model';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PostgreSqlDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts,
    disabled: __IS_FABRIC_DPE__
})
export class PostgreSqlDatasetAdapter extends TabularTypeDatasetAdapter<PostgreSqlDataset, Model.DatasetResource> {
}
